import { makeStyles } from "tss-react/mui";
const styles = makeStyles()((theme)=>({
        extraSmall: {
            '&.MuiIconButton-sizeSmall': {
                padding: theme.tokens.spacing['4'],
                height: theme.px(24),
                width: theme.px(24)
            }
        }
    }));
const IconButton_styles = styles;
export default IconButton_styles;
